var map = {
	"./bedroom.png": "./src/images/Whampoa/bedroom.png",
	"./bedroom2.png": "./src/images/Whampoa/bedroom2.png",
	"./door.png": "./src/images/Whampoa/door.png",
	"./livingroom.png": "./src/images/Whampoa/livingroom.png",
	"./livingroom2.png": "./src/images/Whampoa/livingroom2.png",
	"./livingroom3.png": "./src/images/Whampoa/livingroom3.png",
	"./orridor.png": "./src/images/Whampoa/orridor.png",
	"./wc.png": "./src/images/Whampoa/wc.png",
	"./wc2.png": "./src/images/Whampoa/wc2.png",
	"./wc3.png": "./src/images/Whampoa/wc3.png",
	"./wc4.png": "./src/images/Whampoa/wc4.png",
	"./wc5.png": "./src/images/Whampoa/wc5.png",
	"./wc6.png": "./src/images/Whampoa/wc6.png",
	"./wc7.png": "./src/images/Whampoa/wc7.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/Whampoa sync recursive \\.(png%7Cjpe?g%7Csvg)$";